import { useEffect } from "react";
import eventBus, { EventBusSubscription } from "@sd-utility/eventbus";
import { OPEN_POPUP_EVENT } from "client/utils/constants";
import { Subscription } from "rxjs";

export const useEventBus = (openModal: () => void) => {
  useEffect(() => {
    let shopdirectSubscription: Subscription;
    let eventBusSubscription: EventBusSubscription;
    if (window.shopdirect?.event) {
      shopdirectSubscription = window.shopdirect.event.subscribe(
        OPEN_POPUP_EVENT,
        openModal,
      );
    }
    if (eventBus) {
      eventBusSubscription = eventBus.subscribe(OPEN_POPUP_EVENT, () => {
        openModal();
      });
    }
    return () => {
      if (shopdirectSubscription) {
        shopdirectSubscription.unsubscribe();
      }
      if (eventBusSubscription) {
        eventBusSubscription.unsubscribe();
      }
    };
  }, [openModal]);
};
